<template>
  <div class="bank-selector" :class="{ 'open-selector': openSelector, loading: loading }">
    <div v-if="!selectedBank" @click="toggleDropdown" class="selected-bank bank none-selected">
      <div class="bank-logo">
        <font-awesome-icon icon="fa-solid fa-building-columns" />
      </div>
      <div class="bank-name">
        <div class="bank-name--bankname">
          <span>{{ $gettext('Select your bank') }}</span>
        </div>
      </div>
      <font-awesome-icon :icon="selectorCaret" class="selector-caret" />
    </div>
    <div v-if="selectedBank" class="selected-bank bank none-selected">
      <div class="bank-logo">
        <img v-if="selectedBank.icon" :src="selectedBank.icon" :alt="selectedBank.name">
        <font-awesome-icon v-else icon="fa-solid fa-building-columns" />
      </div>
      <div class="bank-name">
        <div class="bank-name--bankname">
          <span>{{ selectedBank.name }}</span>
        </div>
      </div>
    </div>
    <div class="options-list-wrap" :style="cssVars">
      <overlay-scrollbars :options="scrollBarOptions" class="selector-scrollbar">
        <div class="options-list">
          <div v-for="bank in bankList['']" :key="'bank_' + bank.code" @click="selectBank(bank.code)" class="bank" :class="{ selected: selectedCode === bank.code }">
            <div class="bank-logo">
              <img v-if="bank.icon" :src="bank.icon" :alt="bank.name">
              <div v-else class="no-logo">
                <font-awesome-icon :icon="'fa-regular fa-image-slash'" />
              </div>
            </div>
            <div class="bank-name">
              <div class="bank-name--descriptor">
                <span>{{ bank.name }}</span>
              </div>
            </div>
          </div>

          <div v-for="bank in availableBanks" :key="'bank_' + bank.code" @click="selectBank(bank.code)" class="bank" :class="{ selected: selectedCode === bank.code }">
            <div class="bank-logo">
              <img v-if="bank.icon" :src="bank.icon" :alt="bank.name">
              <div v-else class="no-logo">
                <font-awesome-icon :icon="'fa-regular fa-image-slash'" />
              </div>
            </div>
            <div class="bank-name">
              <div class="bank-name--descriptor">
                <span>{{ bank.name }}</span>
              </div>
            </div>
          </div>

        </div>
      </overlay-scrollbars>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  name: 'BankProviderSelector',
  components: { 
  },
  props: {
    selectedCountry: {
      type: String,
      default: 'NL'
    },
  },
  data () {
    return {
      openSelector: false,
      selectedCode: null,
      loading: true,
      scrollBarOptions: {
        scrollbars: { 
          autoHide: "never",
          dragScrolling: true,
          clickScrolling: true,
          touchSupport: true,
          snapHandle: true
        }, 
        overflowBehavior: { y: 'scroll', x: 'scroll' },
      },
      bankList: []
    }
  },
  computed: {
    ...mapGetters ({
      currentCompany: "main/getCurrentCompany",
      enablenowProviders: "bankStore/getEnablenowProviders"
    }),
    availableBanks () {
      return this.bankList[this.selectedCountry.toLowerCase()]
    },
    selectedBank () {
      if (Array.isArray(this.availableBanks)) {
        const selectedBank = this.availableBanks.find(bank => bank.code === this.selectedCode)
        return (selectedBank) ? selectedBank : null
      } else {
        return null
      }
    },
    selectorCaret () {
      return (this.openSelector) ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'
    },
    cssVars () {
      let sel_items = (this.availableBanks) ? this.availableBanks.length : 0
      return {
        '--sel-items': sel_items,
      }
    }
  },
  created () {
    this.setupData()
  },
  mounted () {
    document.addEventListener('click', this.close)
  },
  beforeDestroy () {
    document.removeEventListener('click',this.close)
  },
  methods: {
    ...mapActions({
      loadEnablenowProviders: "bankStore/loadEnablenowProviders"
    }),
    async setupData () {
      this.loading = true
      if (this.enablenowProviders.length == 0){
        await this.loadEnablenowProviders()
      }
      this.bankList = {};
      this.enablenowProviders.forEach(a_provider => {
        var temp = {name: a_provider.name, code: a_provider.providerKey, icon: a_provider.logoUrl}
        if(this.bankList[a_provider.countryCode]){
          this.bankList[a_provider.countryCode].push(temp)
        }else{
          this.bankList[a_provider.countryCode] = [temp]
        }
      });
      this.loading = false
    },
    toggleDropdown () {
      this.openSelector = !this.openSelector
    },
    selectBank (bank_code) {
      if (this.selectedCode === bank_code) return false
      this.selectedCode = bank_code
      this.openSelector = !this.openSelector
      this.$emit('change', bank_code)
    },
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.openSelector = false
      }
    }
  }
}
</script>
<style lang="scss">
  .bank-selector {
    .options-list-wrap {
      border: 1px solid transparent;
      border-radius: $radiusLg;

      .os-host { 
        height: 100% !important;
        .os-content { padding: 0 !important; }
        &.os-host-overflow-y {
          .os-content { padding-right: 0.5rem !important; }
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
  .bank-selector {
    box-shadow: $filtersShadow;
    border-radius: $radiusMd;
    // background: $colorBlue100;
    background: white;
    padding: 0.5rem;

    position: relative;
    &.loading { overflow: hidden; }
    .selector-caret {
      font-size: 16px;
      color: $colorBlue;
      margin-left: 0.25rem;
    }
    .bank {
      display: flex;
      align-items: center;
      border-radius: $radiusSm;
      .bank-logo {
        border-radius: 100px;
        overflow: hidden;
        display: flex;
        height: 100%;
        aspect-ratio: 1;
        width: 44px;
        margin-right: 0.5rem;
        flex-shrink: 0;
        img { width: 100%; }

        background: #f2f2f2;

        display: flex;
        justify-content: center;
        align-items: center;
        .svg-inline--fa {
          font-size: 1rem;
          opacity: 0.3;
        }
        img { 
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
        .no-logo {
          padding: 5px;
          text-align: center;
          line-height: 1rem;
          font-size: 14px;
        }
      }
      .bank-name {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        white-space: nowrap;
        font-family: DINNextLTPro-Medium, sans-serif;
        font-size: 20px; 
        &--descriptor {
          line-height: 1;
          white-space: nowrap;
          font-size: 18px;
        }
        span { 
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .selected-bank {
      height: 100%;
      cursor: pointer;
      &.none-selected {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        font-family: DINNextLTPro-Medium, sans-serif;
        font-size: 20px; 
        gap: 0.25rem;
        .bank-logo {
          .svg-inline--fa {
            opacity: 0.5;
            font-size: 20px;
          }
        }
      }
      .bank-logo {
        height: 100%;
        aspect-ratio: 1;
        width: 48px;
      }
      .bank-name {
        padding-right: 0.5rem;
        &--descriptor {
          font-size: 18px;
        }
      }
    }
    &.open-selector {
      .options-list-wrap {
        $baseItemHeight: 50px;
        $itemHeight: calc(#{$baseItemHeight} + 0.5rem);
        $selHeight: calc(#{$itemHeight} * var(--sel-items));
        height: calc(#{$selHeight} + 10px); // border size 10px + add new button
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: $dropdownShadow;
        z-index: 110;
      }
    }
    .options-list-wrap {
      z-index: 100;
      position: absolute;
      top: calc(100% + 0.25rem);
      left: 0;
      height: 0;
      width: 100%;
      max-height: 300px;
      max-width: 300px;
      transition: height 0.2s ease-in-out;
      overflow: hidden;
      border-radius: $radiusLg;
      background: white;
      text-align: center;
      .options-list {
        padding: 0.5rem;
        width: 100%;
        .bank {
          padding: 0.5rem;
          transition: all 0.2s ease;
          cursor: pointer;
          &.selected {
            opacity: 0.3;
            background-color: $colorUnassigned200;
            &:hover { background-color: $colorUnassigned200; }
          }
          &:hover {
            background: rgba(34, 172, 138, 0.07);
            color: #06926f;
          }
          &:not(:last-child) {
            margin-bottom: 0.5rem;
          }
        }
      }
      
    }
  }
</style>
